import { jsx } from "panel";
import { assertUnreachable } from "common/util/typescript";
import { formatText } from "common/util/format-text";
import { SvgIconEl } from "common/components/svg-icon";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerSize } from "common/components/spinner/types";
import { MarkdownEl } from "../markdown";
import { WarningTheme } from "./constants";
function Icon({ theme, imgSrc }) {
  if (imgSrc) {
    return /* @__PURE__ */ jsx("img", {
      attrs: { src: imgSrc }
    });
  }
  switch (theme) {
    case WarningTheme.Error:
      return /* @__PURE__ */ jsx(SvgIconEl, {
        attrs: { icon: `warning` }
      });
    case WarningTheme.Sensitive:
      return /* @__PURE__ */ jsx(SvgIconEl, {
        attrs: { icon: `lock` }
      });
    case WarningTheme.NoData:
      return /* @__PURE__ */ jsx("div", {
        sel: ".mp-warning-no-data-svg"
      });
    case WarningTheme.NoIcon:
      return null;
    case WarningTheme.Default:
      return /* @__PURE__ */ jsx("div", {
        sel: ".mp-warning-laptop-svg"
      });
    case WarningTheme.Loading:
      return /* @__PURE__ */ jsx(SpinnerEl, {
        attrs: { "allow-festive": true, size: SpinnerSize.Large }
      });
    case WarningTheme.Tip:
      return null;
    default:
      assertUnreachable(theme);
  }
}
function BodyText({ text }) {
  if (!text) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    sel: ".body-text",
    attrs: { elref: `bodyText` }
  }, text.split(`
`).map((line, idx) => /* @__PURE__ */ jsx(null, null, idx ? /* @__PURE__ */ jsx("br", null) : null, formatText(line))));
}
export function template() {
  const theme = this.attr(`theme`);
  const href = this.attr(`cta-href`);
  const imgSrc = this.attr(`img-src`);
  const bodyText = this.attr(`body-text`);
  const themeClass = theme === WarningTheme.Tip ? { "theme-tip": true } : {};
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-warning-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-warning-content"
  }, /* @__PURE__ */ jsx(Icon, {
    theme,
    imgSrc
  }), this.attr(`header-text`) && /* @__PURE__ */ jsx("h1", {
    attrs: { elref: `headerText` },
    class: themeClass
  }, this.attr(`header-text`)), theme === WarningTheme.Tip ? /* @__PURE__ */ jsx(MarkdownEl, {
    attrs: { text: bodyText },
    class: themeClass
  }) : /* @__PURE__ */ jsx(BodyText, {
    text: bodyText
  })), /* @__PURE__ */ jsx("slot", null), this.attr(`cta-text`) && /* @__PURE__ */ jsx("a", {
    sel: ".mp-warning-cta",
    attrs: { href },
    on: { click: href ? null : this.helpers.handleCtaClick }
  }, this.attr(`cta-text`), /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `arrow-right` }
  })));
}
